module.exports = __webpack_public_path__ + "media/markers/cluster-default-bc760f3a.png";